var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view_container"},[_c('Header'),(!_vm.isSafari && !_vm.isIOS)?_c('AddVideo'):_vm._e(),(_vm.isSafari && !_vm.isIOS)?_c('AddVideoTwilio'):_vm._e(),(_vm.isIOS)?_c('AddVideoWithFileUpload'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }